import { TranslationsContext } from '@teliaee/telia-translate';
import { Grid, GridColumn, Table, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../../stores/RoamingStore';

interface OperatorGeneralInfoProps {
  roamingStore?: RoamingStore;
}

@observer
class OperatorGeneralInfo extends React.Component<OperatorGeneralInfoProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    const {
      roamingStore: { selectedOperator }
    } = this.props;
    if (!selectedOperator) {
      return null;
    }
    return (
      <Grid>
        <GridColumn>
          <Text>
            <p className="text-small text-light">{translate('roaming.operator.chosen')}</p>
            <p className="h3 text-weight-normal text__margin-none">{selectedOperator.name}</p>
            <Table>
              <tbody>{this.getOperatorGeneralInfoTableRows()}</tbody>
            </Table>
            {/*
          Coverage map urls are broken, uncomment if fixed on roaming-api side
          {this.renderCoverageMapButton()}
          */}
          </Text>
        </GridColumn>
      </Grid>
    );
  }
  /*
  private renderCoverageMapButton() {
    const translate = this.context.translate;
    const {
      roamingStore: { selectedOperator }
    } = this.props;
    return <Button text={translate('roaming.operator.coverage-map')} link={true} iconLeft="#map-marker" url={selectedOperator.coverageMap} target="_blank" />;
  }
*/
  private getOperatorGeneralInfoTableRows() {
    const translate = this.context.translate;
    const {
      roamingStore: { selectedOperator }
    } = this.props;
    const keyPrefix = `operator-${selectedOperator.id}`;
    const dataRows: any = [];
    if (selectedOperator.shortName) {
      this.pushRow(dataRows, `${keyPrefix}-short-name`, translate('roaming.operator.short-name'), selectedOperator.shortName);
    }
    if (selectedOperator.network) {
      this.pushRow(dataRows, `${keyPrefix}-network`, translate('roaming.operator.network'), selectedOperator.network);
    }
    if (selectedOperator.networkType) {
      this.pushRow(dataRows, `${keyPrefix}-network-type`, translate('roaming.operator.network-type'), selectedOperator.networkType);
    }
    if (selectedOperator.operatorCodes.length) {
      this.pushRow(dataRows, `${keyPrefix}-operator-code`, translate('roaming.operator.operator-code'), selectedOperator.operatorCodes.join('; '));
    }
    if (selectedOperator.operatorCodesOnBill.length) {
      this.pushRow(
        dataRows,
        `${keyPrefix}-operator-code-on-bill`,
        translate('roaming.operator.operator-code-on-bill'),
        selectedOperator.operatorCodesOnBill.join('; ')
      );
    }
    if (selectedOperator.intInfo) {
      this.pushRow(dataRows, `${keyPrefix}-international-info`, translate('roaming.operator.info-international'), selectedOperator.intInfo);
    }
    if (selectedOperator.infoOnGsm) {
      this.pushRow(dataRows, `${keyPrefix}-info-on-gsm`, translate('roaming.operator.info-on-gsm'), selectedOperator.infoOnGsm);
    }
    if (selectedOperator.openNetworks && selectedOperator.openNetworks.length) {
      this.pushRow(
        dataRows,
        `${keyPrefix}-open-networks`,
        translate('roaming.operator.open-networks'),
        selectedOperator.openNetworks.slice().sort().join(', ')
      );
    }
    return dataRows;
  }

  private pushRow(array: any[], key: string, name: string, value: string) {
    array.push(
      <tr key={key}>
        <th>{name}</th>
        <td className="text-right">{value}</td>
      </tr>
    );
  }
}

export default inject('roamingStore')(OperatorGeneralInfo);
